import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './international-payment.component.scss';
var InternationalPayment = /** @class */ (function (_super) {
    tslib_1.__extends(InternationalPayment, _super);
    function InternationalPayment(element, analyticsService) {
        var _this = _super.call(this, element) || this;
        _this.count = 1;
        _this.iSstep1Completed = false;
        _this.iSstep2Completed = false;
        _this.errors = [];
        return _this;
    }
    InternationalPayment.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.recipientInput = this.element.querySelector("input[name=recipient]");
        this.emailInput = this.element.querySelector("input[name=email]");
        this.subjectInput = this.element.querySelector("input[name=subject]");
        this.hiddenEmail = this.element.querySelector("input[name=email]");
        this.hiddenRecipient = this.element.querySelector("input[name=recipient]");
        this.wizardContainer = this.element.querySelector(".form-container-wizard__wizard");
        this.wizardStepsContainer = this.element.querySelector(".form-container-wizard__steps");
        this.bulletContainer = this.element.querySelector(".form-container-wizard__bullets-container");
        this.customHeading = this.element.querySelector(".customHeading");
        this.stepNo = this.element.querySelector(".form-container-wizard__stepno");
        // buttons
        this.closeButton = this.element.querySelector(".js-apply-now-modal-close");
        this.backButton = Array.from(this.element.querySelectorAll(".js_prev-step-button"));
        this.step1Button = this.element.querySelector(".js_next-step1-button");
        this.showStep(1);
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector(".form-container__error");
            this.displayDecline = this.form.querySelector(".form-container__declined");
        }
        this.buttonSubmit = this.element.querySelector(".js_submit-button");
        this.doneSubmit = this.element.querySelector(".js_done-button");
        this.showMoreBtn = this.element.querySelector(".data-privacy-collapse-show");
        this.showLessBtn = this.element.querySelector(".data-privacy-collapse-hide");
        this.dataPrivacyDetailArea = this.element.querySelector(".data-privacy-detail");
        this.dataSharingGroupHideBtn = this.element.querySelector(".data-sharing-group-hide-btn");
        this.dataSharingGroupShowBtn = this.element.querySelector(".data-sharing-group-show-btn");
        this.dataSharingGroupTextArea = this.element.querySelector(".data-sharing-group");
        this.dataSharing3rdPartyShowBtn = this.element.querySelector(".data-sharing-3rd-party-show-btn");
        this.dataSharing3rdPartyHideBtn = this.element.querySelector(".data-sharing-3rd-party-hide-btn");
        this.dataSharing3rdPartyTextArea = this.element.querySelector(".data-sharing-3rd-party");
        this.dataSharingBoardersHideBtn = this.element.querySelector(".data-sharing-boarders-hide-btn");
        this.dataSharingBoardersShowBtn = this.element.querySelector(".data-sharing-boarders-show-btn");
        this.dataSharingBoardersTextArea = this.element.querySelector(".data-sharing-boarders");
        //Analytics
        this.form.setAttribute("data-frmcontainer", "international payment | personal details");
        this.analyticsService.startDtmApplication("application: foreign exchange | international payment", "international payment");
        this.updatePageName("step 1 personal details form");
    };
    InternationalPayment.prototype.bindEvents = function () {
        var _this = this;
        //Step 1 Next Button
        if (this.step1Button) {
            this.step1Button.addEventListener("click", function (pEvent) {
                var _form = _this.form.querySelector(".step1");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                var validContact = Array.from(_form.querySelectorAll(".form__group--error_message"));
                if (valid.length === 0 && validContact.length === 0) {
                    _this.count += 1;
                    if (!_this.iSstep1Completed && !dataLayer.formisSubmitted)
                        _this.analyticsService.dtmFormComplete("complete", "", true);
                    _this.iSstep1Completed = true;
                    _this.dtmVirtualPage("step 2 additional details form");
                    _this.showStep(2);
                }
            });
        }
        //Step 2 Submit Button Click
        if (this.buttonSubmit) {
            this.buttonSubmit.addEventListener("click", function (pEvent) {
                var _form = _this.form.querySelector(".step2");
                var formFields = _form.querySelectorAll("input, select, textarea");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.submitForm(_this.form);
                }
            });
        }
        //Back button
        if (this.backButton.length) {
            this.backButton.map(function (item) {
                return item.addEventListener("click", function (event) {
                    _this.showPreviousStep(event);
                });
            });
        }
        if (this.doneSubmit) {
            this.doneSubmit.addEventListener("click", function (event) {
                return _this.closeForm("done");
            });
        }
        if (this.closeButton) {
            this.closeButton.addEventListener("click", function (event) {
                return _this.closeForm("close");
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        this.showLessBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.showLessBtn.setAttribute("hidden", "true");
            _this.showMoreBtn.removeAttribute("hidden");
            _this.dataPrivacyDetailArea.setAttribute("hidden", "true");
        });
        this.showMoreBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.showMoreBtn.setAttribute("hidden", "true");
            _this.showLessBtn.removeAttribute("hidden");
            _this.dataPrivacyDetailArea.removeAttribute("hidden");
        });
        this.dataSharingGroupHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.setAttribute("hidden", "true");
            _this.dataSharingGroupHideBtn.setAttribute("hidden", "true");
            _this.dataSharingGroupShowBtn.removeAttribute("hidden");
        });
        this.dataSharingGroupShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.removeAttribute("hidden");
            _this.dataSharingGroupHideBtn.removeAttribute("hidden");
            _this.dataSharingGroupShowBtn.setAttribute("hidden", "true");
        });
        this.dataSharing3rdPartyHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.setAttribute("hidden", "true");
            _this.dataSharing3rdPartyShowBtn.removeAttribute("hidden");
            _this.dataSharing3rdPartyHideBtn.setAttribute("hidden", "true");
        });
        this.dataSharing3rdPartyShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.removeAttribute("hidden");
            _this.dataSharing3rdPartyHideBtn.removeAttribute("hidden");
            _this.dataSharing3rdPartyShowBtn.setAttribute("hidden", "true");
        });
        this.dataSharingBoardersShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.removeAttribute("hidden");
            _this.dataSharingBoardersShowBtn.setAttribute("hidden", "true");
            _this.dataSharingBoardersHideBtn.removeAttribute("hidden");
        });
        this.dataSharingBoardersHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.setAttribute("hidden", "true");
            _this.dataSharingBoardersHideBtn.setAttribute("hidden", "true");
            _this.dataSharingBoardersShowBtn.removeAttribute("hidden");
        });
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
    };
    InternationalPayment.prototype.closeForm = function (type) {
        if (type === "close") {
            this.analyticsService.dtmFormAbandon();
        }
        else {
            // this.analyticsService.dtmFormComplete(`complete`, `true`);
            // this.analyticsService.completeDtmApplication();
        }
        this.form.reset();
        window.location.href =
            "/southafrica/business/products-and-services/bank-with-us/foreign-exchange/business-international-payments";
    };
    InternationalPayment.prototype.showStep = function (stepId) {
        var showStep = parseFloat(stepId);
        if (this.bulletContainer) {
            var _bullets = Array.from(this.bulletContainer.querySelectorAll(".form-container-wizard__bullets-container--bullet"));
            _bullets.map(function (pItem) {
                var displayStep = parseFloat(pItem.getAttribute("data-step"));
                if (displayStep <= showStep) {
                    pItem.classList.add("form-container-wizard__bullets-container--bullet--active");
                }
                else {
                    pItem.classList.remove("form-container-wizard__bullets-container--bullet--active");
                }
            });
            var _bulletLines = Array.from(this.bulletContainer.querySelectorAll(".form-item-business-solar-loan__form-container-wizard__bullets-container--bullet--link"));
            _bulletLines.map(function (pItem) {
                var displayStep = parseFloat(pItem.getAttribute("data-step"));
                if (showStep > displayStep) {
                    pItem.classList.add("form-item-business-solar-loan__form-container-wizard__bullets-container--bullet--link--active");
                }
                else {
                    pItem.classList.remove("form-item-business-solar-loan__form-container-wizard__bullets-container--bullet--link--active");
                }
            });
        }
        var _steps = Array.from(this.wizardStepsContainer.querySelectorAll(".form-container-wizard__steps--step"));
        var _heading = "";
        _steps.map(function (pStep) {
            var _step = parseFloat(pStep.getAttribute("data-step"));
            if (_step == showStep) {
                _heading = pStep.getAttribute("data-heading");
                pStep.classList.remove("form-container-wizard__steps--hidden");
            }
            else {
                pStep.classList.add("form-container-wizard__steps--hidden");
            }
        });
        var _stepno = this.stepNo.querySelector("h6");
        if (_stepno != null) {
            _stepno.innerHTML = "STEP " + showStep + " OF 2";
        }
        window.scrollTo(0, 0);
    };
    InternationalPayment.prototype.showPreviousStep = function (event) {
        this.showDisplayView("");
        var _target = event.currentTarget;
        var _currentStep = _target.closest("[data-step]");
        var _nextStep = _currentStep.getAttribute("data-step");
        this.showStep(parseFloat(_nextStep));
        window.scrollTo(0, 0);
    };
    InternationalPayment.prototype.submitForm = function (form) {
        var _this = this;
        // success screens
        var _serviceType = form.querySelector("input[name=service-type]");
        var _firstname = this.form.querySelector("input[name=first-name]");
        var _surname = this.form.querySelector("input[name=last-name]");
        var _contactNumber = this.form.querySelector("input[name=phone-number]");
        var _emailAddress = this.form.querySelector("input[name=email-address]");
        var _title = this.form.querySelector("select[name=name-title]");
        var _international_product = this.form.querySelector("select[name=international-product]");
        var _digital_platform = this.form.querySelector("select[name=digital-platform]");
        var _time = this.form.querySelector("select[name=time]");
        var _description = form.querySelector("textarea[name=description]");
        var _recipient = form.querySelector("input[name=recipient]");
        var _subject = form.querySelector("input[name=subject]");
        var _product = form.querySelector("input[name=product]");
        var _redirect = form.querySelector("input[name=redirect]");
        var _email = form.querySelector("input[name=email]");
        var _popiaConsent = form.querySelector("input[name=popia-consent]");
        var _businessName = form.querySelector("input[name=business-name]");
        var _postData = {
            'serviceType': (_serviceType ? _serviceType.value : ""),
            'firstName': (_firstname ? _firstname.value : ""),
            'surname': (_surname ? _surname.value : ""),
            'contactNo': (_contactNumber ? _contactNumber.value : ""),
            'emailAddress': (_emailAddress ? _emailAddress.value : ""),
            'email': (_email ? _email.value : ""),
            'recipient': (_recipient ? _recipient.value : ""),
            'subject': (_subject ? _subject.value : ""),
            'product': (_product ? _product.value : ""),
            'title': (_title ? _title.value : ""),
            'internationalProduct': (_international_product ? _international_product.value : ""),
            'time': (_time ? _time.value : ""),
            'digital_platform': (_digital_platform ? _digital_platform.value : ""),
            'description': (_description ? _description.value : ""),
            'redirect': (_redirect ? _redirect.value : ""),
            'businessName': (_businessName ? _businessName.value : ""),
            'consent': ((_popiaConsent ? (_popiaConsent.checked ? "YES" : "NO") : "NO")),
            dataSharingWithinOurGrpMarketingConsent: this.dataConsentService.getDataConsentValue(form, 'data-sharing-group'),
            dataSharingWithThirdPartiesMarketingConsent: this.dataConsentService.getDataConsentValue(form, 'data-sharing-3rd-party'),
            dataSharingAcrossBordersWithinOurGrpMarketingConsent: this.dataConsentService.getDataConsentValue(form, 'data-sharing-boarders'),
            'formLocation': this.formLocationService.getLocation(),
        };
        this.showDisplayView("loader");
        var url = this.baseUrl + "/bcleadUtils/international-payment-lead";
        var _config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, _postData, _config)
            .then(function (pResponse) {
            if (pResponse.data === "invalid") {
                _this.analyticsService.dtmFormComplete("complete", pResponse.code, false);
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.showDisplayView("error");
            }
            else {
                _this.dtmVirtualPage("step 2 success form");
                if (!_this.iSstep2Completed && !dataLayer.formisSubmitted)
                    _this.analyticsService.dtmFormComplete("complete", pResponse.code, true);
                _this.iSstep2Completed = true;
                _this.analyticsService.completeDtmApplication();
                _this.dtmVirtualPage('thank you');
                _this.showDisplayView("success");
            }
        })
            .catch(function (pError) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    InternationalPayment.prototype.showDisplayView = function (pDisplay) {
        window.scroll({ top: 50, behavior: "smooth" });
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        this.displayDecline.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            case "decline":
                this.displayDecline.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
        }
    };
    InternationalPayment.prototype.dtmVirtualPage = function (pPageNameNew) {
        dataLayer.pageName =
            "business:bank with us:foreign exchange:international payment :" +
                pPageNameNew;
        if (typeof _satellite == "object") {
            _satellite.track("globalVirtualPageView");
        }
    };
    InternationalPayment.prototype.updatePageName = function (pageName) {
        dataLayer.pageName =
            "business:bank with us:foreign exchange:international payment :" +
                pageName;
    };
    return InternationalPayment;
}(Base));
export { InternationalPayment };



//////////////////
// WEBPACK FOOTER
// ./components/international-payment/international-payment.component.ts
// module id = 707
// module chunks = 0